import moment from 'moment'
import { Typography } from '../../../../../../components/Typography'
import { FieldWithLabel } from '../../../../../../components/FieldWithLabel/FieldWithLabel'
import {
  FINANCIAL_STATUS_TYPES_TO_CLASSNAME,
  Status
} from '../../../../../../components/Status'
import { currencyFormatter } from '../../../../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { timelineDateFormat } from '../../../../../../components/Timelines/constants'
import { FINANCIAL_STATUS_LABEL } from '../../../../constants'
import { InvoicesDetailsProps } from './types'

export const InvoicesDetailsGeneral = ({
  invoiceData,
  showVendor = true,
  showHSName
}: InvoicesDetailsProps) => (
  <div className="invoices-details__general column gap-16">
    <div className="row gap-12">
      <Typography.Headline6>General</Typography.Headline6>
      <Status.Default
        className={FINANCIAL_STATUS_TYPES_TO_CLASSNAME[invoiceData.status]}
      >
        {FINANCIAL_STATUS_LABEL[invoiceData.status]}
      </Status.Default>
    </div>
    <div className="row gap-24">
      {showVendor && (
        <FieldWithLabel title="Vendor">
          {invoiceData.supplier_name}
        </FieldWithLabel>
      )}
      {showHSName && (
        <FieldWithLabel title="HS Name">
          {invoiceData.health_system_name}
        </FieldWithLabel>
      )}
      <FieldWithLabel title="Total">
        ${currencyFormatter(invoiceData.total)}
      </FieldWithLabel>
      <FieldWithLabel title="Period ending">
        {invoiceData.period_ending
          ? moment(invoiceData.period_ending).format(timelineDateFormat)
          : '-'}
      </FieldWithLabel>
      <FieldWithLabel title="Due date">
        {invoiceData.due_date
          ? moment(invoiceData.due_date).format(timelineDateFormat)
          : '-'}
      </FieldWithLabel>
    </div>
  </div>
)
